export const routes = [
    {
        context: 'assistant',
        method: 'POST',
        path: '/messages',
        operationId: 'Messages_create',
        auth: 'tenant',
        action: 'assistant:converse',
        assistantExempt: 'the model call itself: as a tool, the assistant would call itself',
        description: "Ask a model of the given class and get its reply. The plan's limits are checked before the\ncall (429 when one is reached, 403 when the plan has no assistant); the call is metered for\nthe workspace and the caller.",
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
    {
        context: 'assistant',
        method: 'GET',
        path: '/usage',
        operationId: 'Usage_get',
        auth: 'tenant',
        action: 'assistant:read-usage',
        tool: 'assistant_Usage_get',
        description: "The workspace's assistant usage and cost this month and today, against its plan's limits, per person, with the newest calls.",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
];
//# sourceMappingURL=routes.js.map